import {
  checkDuplicatePatient,
  createPatient,
  exportExcelPatientList,
  getPatientInfo,
  pagingPatient,
  voidedPatient,
} from "app/services/PatientService";
import { makeAutoObservable } from "mobx";

import Config, {
  CHECK_ELASTIC_LEADS,
  CHECK_LENGTH_SEARCH_CUSTOMER,
  CUSTOMER_SOURCE_WALK_IN_CODE,
} from "app/appConfig";
import { LIST_GENDER, PAGESIZE_ALL, PathModule } from "app/common/LocalConst";
import {
  convertDataLead,
  getCurrentStaff,
  getSourceCustomerCompanionCode,
  isRoleHisReadOnly,
  isSuperAdmin,
  normalizeDataForServer,
} from "app/common/LocalFunction";
import { CheckIn } from "app/common/Model/CheckIn";
import { CheckOut } from "app/common/Model/CheckOut";
import { Customer } from "app/common/Model/Customer";
import { SearchObject } from "app/common/Model/SearchObject";
import { PageResponse } from "app/common/Model/Shared";
import { pagingCountry } from "app/services/CountryService";
import { pagingCustomerSource } from "app/services/CustomerSourceService";
import {
  pagingElasticLeads,
  pagingElasticPatient,
} from "app/services/ElasticPatient";
import { pagingLead } from "app/services/LeadCRMService";
import localStorageService from "app/services/localStorageService";
import {
  checkCompanions,
  checkIn,
  checkOut,
} from "app/services/ReceptionService";
import { pagingVisitType } from "app/services/VisitTypeService";
import history from "history.js";
import { toast } from "react-toastify";

export default class PatientListStore {
  searchPatient = {
    ...new SearchObject(),
    // fromDate: new Date(new Date().getFullYear(), 0, 1),
    // toDate: new Date(),
    patientCreateFromDate: null,
    patientCreateToDate: null,
    fromAppointment: null,
    toAppointment: null,
    fromVisit: null,
    toVisit: null,
    fromInvoiceDate: null,
    toInvoiceDate: null,
    departmentId: null,
    appointmentDepId: null,
    visitDepId: null,
    invoiceDepId: null,
    apptStatus: null,
  };
  pagePatient = new PageResponse();
  searchLead = { ...new SearchObject(), pageSize: 10 };
  searchDuplicatePatient = {
    ...new SearchObject(),
    phoneNumber: "",
    searchArchive: false,
  };
  leadPatient = null; //list lead search by sdt
  openFormCreateOrEdit = false; //form create & edit
  openFormCheckIn = false; //form check in
  openFormCheckOut = false; //form check out
  openConfirmDelete = false; //dialog delete
  openSearchLead = false; //form search lead in popup create patient
  openDuplicatePatientPopup = false; //form duplicate patient
  openDupPatientByPhones = null; //TH nếu có dupPatientPhone
  duplicatePatients = null;
  openPopupSearchDependentPersonLead = false;
  initialPatient = new Customer();
  initialCheckIn = {
    ...new CheckIn(),
    receptionist: getCurrentStaff(),
    department: localStorageService.getDefaultDepartment(),
  };
  initialCheckOut = {
    ...new CheckOut(),
    // department: localStorageService.getDefaultDepartment(),
  };
  leadSelected = null; // select lead from lead search popup
  duplicatePatientSelected = null; // select patient from duplicate patient popup
  openConfirmCheckIn = null;
  openConfirmCheckOut = null;
  openConfirmHasAppointment = null;
  selectedPatient = new Customer(); // select patient when click patient in patient list data screen;
  openShowPatientInfo = false; //open when click patient in patient list data screen;
  openCheckInDependentPersonPopup = false;
  initCheckInDependentPerson = null;
  openPopupCheckDuplicateDependentPerson = false;
  listCompanionsSearchDuplicateIndex = new Set([]);
  customerSourceForCompanionDefault = null;
  openDupPatientByPhonesDependentPopup = null;
  openConfirmCheckIns = null;
  showSearchError = false;
  searchCheckIn = {
    ...new SearchObject(),
    fromDate: new Date(),
    toDate: new Date(),
    hasBill: null,
    hasRevenue: null,
    hasDebt: null,
    hasAppointment: null,
    sourceId: null,
    sourceDetailId: null,
  };

  showSearchError = false;
  constructor() {
    makeAutoObservable(this);
  }

  pagingPatient = async () => {
    const ortherData = this.normalizeSearchPatient(this.searchPatient);
    return await pagingPatient({ ...ortherData })
      .then(({ data }) => {
        this.pagePatient = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu khách hàng có lỗi");
      });
  };

  handleChangeFormSearch = (searchPatient) => {
    this.searchPatient = { ...this.searchPatient, ...searchPatient };
    const isReadAllPermission = isSuperAdmin() || isRoleHisReadOnly();

    const { patientName, code, phoneNumber } = this.searchPatient;

    const CheckSeachNameCodePhone =
      patientName?.trim() || code?.trim() || phoneNumber?.trim();

    if (!isReadAllPermission && !CheckSeachNameCodePhone) {
      this.showSearchError = true;
      return;
    }
    if (isReadAllPermission) {
      this.showSearchError = false;
      this.pagingPatient();
    } else {
      // gõ đủ kí tự ms cho tìm
      const isFielLength =
        (patientName?.trim()?.length || 0) >= CHECK_LENGTH_SEARCH_CUSTOMER ||
        (code?.trim()?.length || 0) >= CHECK_LENGTH_SEARCH_CUSTOMER ||
        (phoneNumber?.trim()?.length || 0) >= CHECK_LENGTH_SEARCH_CUSTOMER;
      if (isFielLength) {
        this.showSearchError = false;
        this.pagingPatient();
      } else {
        this.showSearchError = true;
      }
    }
  };

  handleOpenFormCreateOrEdit = async (patient) => {
    if (Boolean(patient)) {
      const { data } = await getPatientInfo(patient?.id);
      if (data?.referralPartnerId) {
        data.referralPartner = {
          id: data?.referralPartnerId || "",
          name: data?.referralPartnerName || "",
          code: data?.referralPartnerCode || "",
        };
      }
      this.initialPatient = data;

      this.openFormCreateOrEdit = true;
    } else {
      try {
        let { data } = await pagingCountry({
          keyword: "Việt Nam",
          pageIndex: 1,
          pageSize: 1,
        });
        this.initialPatient = {
          ...new Customer(),
          nationality: data?.content?.[0] || null,
        };
      } catch (error) {
        console.error(error);
        toast.error("Có lỗi xảy ra");
      }
      this.openFormCreateOrEdit = true;
    }
  };

  handleOpenFormCheckIn = async (patient) => {
    const visitType = await this.getVisitType();

    this.initialCheckIn = {
      ...new CheckIn(),
      receptionist: getCurrentStaff(),
      department: localStorageService.getDefaultDepartment(),
      patient,
      visitType,
    };
    this.openFormCheckIn = true;
  };

  getVisitType = async () => {
    return await pagingVisitType({
      pageIndex: 1,
      pageSize: PAGESIZE_ALL,
      keyword: "offline_checkin",
    })
      .then(({ data }) => {
        if (data?.content?.length > 0) {
          return data?.content?.[0];
        }
        return null;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu loại check in có lỗi");
      });
  };

  handleCloseFormCheckIn = () => {
    this.initialCheckIn = {
      ...new CheckIn(),
      receptionist: getCurrentStaff(),
      department: localStorageService.getDefaultDepartment(),
    };
    this.openFormCheckIn = false;
  };

  setOpenConfirmCheckIn = (state) => {
    this.openConfirmCheckIn = state;
  };

  handleOpenFormCheckOut = (patient) => {
    this.initialCheckOut = {
      ...new CheckOut(),
      // receptionist: getCurrentStaff(),
      // department: localStorageService.getDefaultDepartment(),
      patient,
    };
    this.openFormCheckOut = true;
  };

  handleCloseFormCheckOut = () => {
    this.initialCheckOut = {
      ...new CheckOut(),
      // department: localStorageService.getDefaultDepartment(),
    };
    this.openFormCheckOut = false;
  };

  setOpenConfirmCheckOut = (state) => {
    this.openConfirmCheckOut = state;
  };

  setOpenConfirmHasAppointment = (state) => {
    this.openConfirmHasAppointment = state;
  };

  openCheckPhoneNumber = false
  textCheckPhoneNumber = null
  saveOrUpdatePatient = async (patient, { setSubmitting }) => {
    if (!patient?.id) {
      // when create patient ,firstPatientSource or currentPatientSource not provided
      //set default source have code NKV_VL in system config
      if (!patient?.firstPatientSource || !patient?.currentPatientSource) {
        if (CUSTOMER_SOURCE_WALK_IN_CODE) {
          let { data } = await pagingCustomerSource({
            keyword: CUSTOMER_SOURCE_WALK_IN_CODE,
          });
          if (!patient?.firstPatientSource)
            patient.firstPatientSource = data?.content?.[0];
          if (!patient?.currentPatientSource)
            patient.currentPatientSource = data?.content?.[0];
        }
      }
    }
    return createPatient(patient)
      .then(({ data }) => {
        if (data?.responseStatus === false) {
          this.openCheckPhoneNumber= true
          this.textCheckPhoneNumber = data?.responseDetail
        }
        if(data?.id) {
          getPatientInfo(data?.id).then(({ data }) => {
            if (data?.referralPartnerId) {
              data.referralPartner = {
                id: data?.referralPartnerId || "",
                name: data?.referralPartnerName || "",
                code: data?.referralPartnerCode || "",
              };
            }
            this.initialPatient = data;
          });
          toast.success("Lưu thông tin thành công!");
          // this.pagingPatient();
          return data;
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lưu thông tin có lỗi");
      })
      .finally(() => setSubmitting(false));
  };

  handleClosePopupCheckPhoneNumber = () => {
    this.openCheckPhoneNumber = false;
  };

  checkInPatient = (obj, { setSubmitting }) => {
    return checkIn(obj)
      .then(async ({ data }) => {
        if (data && data?.responseStatus) {
          this.openFormCheckIn = false;
          toast.success("Check in thông tin thành công!");
          if (obj?.redirect) {
            history.push(
              Config.ROOT_PATH +
              PathModule.PATIENT_MANAGEMENT +
              `/patient-general?patientId=${data?.patient?.id}`
            );
            this.openFormCreateOrEdit = false;
          }
          if (obj?.isCompanions) {
            this.openCheckInDependentPersonPopup = true;
            await this.getCustomerSourceForCompanionDefault();
            console.log("lot");
            const patient = {
              phoneNumber: data?.patient?.phoneNumber,
              displayName: "",
              gender: LIST_GENDER[1].value,
            };

            this.initCheckInDependentPerson = {
              ...data,
              issueDate: new Date(),
              companions: [
                {
                  patient,
                  issueDate: new Date(),
                  currentPatientSource: this.customerSourceForCompanionDefault,
                },
              ],
            };
          }
        } else if (
          //  has appointment
          data &&
          data?.responseStatus === false &&
          data?.hasAppointment
        ) {
          this.openConfirmHasAppointment = {
            responseDetail: data?.responseDetail,
            appointmentId: data?.appointmentId,
          };
          setSubmitting(false);
          return data?.responseStatus;
        } else if (data && data?.responseStatus === false) {
          if (data?.dupPatientByPhones?.length > 0) {
            //TH sau khi submit mà trùng dup phone
            this.duplicatePatients = data?.dupPatientByPhones;
            this.openDupPatientByPhones = {
              dataValue: obj,
              responseDetail: data?.responseDetail,
            };
          }
          if (data?.checkedIn) {
            //checked in
            this.openConfirmCheckIn = data?.responseDetail;
          }

          setSubmitting(false);
          return data?.responseStatus;
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Check in thông tin có lỗi");
      })
      .finally(() => setSubmitting(false));
  };

  saveCheckCompanions = async (obj, index) => {
    try {
      const { data } = await checkCompanions({
        ...obj,
        currentIndex: index,
      });
      const currentCompanions = data?.companions?.[index];
      if (data && currentCompanions?.responseStatus) {
        this.initCheckInDependentPerson = {
          ...data,
        };

        toast.success("Check in thông tin người đi kèm thành công!");
      } else if (
        //  has appointment
        data &&
        currentCompanions?.responseStatus === false &&
        currentCompanions?.hasAppointment
      ) {
        this.openConfirmHasAppointment = {
          responseDetail: currentCompanions?.responseDetail,
          appointmentId: currentCompanions?.appointmentId,
          companionsIndex: data?.currentIndex,
        };
      } else if (data && currentCompanions?.responseStatus === false) {
        if (currentCompanions?.dupPatientByPhones?.length > 0) {
          //TH sau khi submit mà trùng dup phone
          this.duplicatePatients = currentCompanions?.dupPatientByPhones;
          this.openDupPatientByPhonesDependentPopup = {
            responseDetail: currentCompanions?.responseDetail,
            companionsIndex: data?.currentIndex,
            oldData: obj,
          };
        } else {
          this.openConfirmCheckIns = {
            responseDetail: currentCompanions?.responseDetail,
            companionsIndex: data?.currentIndex,
          };
        }
      }
    } catch (error) {
      toast.error(error);
    }
  };

  handleSelectDupPatientByPhonesDependentPerson = (patient) => {
    const oldCompanions =
      this.openDupPatientByPhonesDependentPopup?.oldData?.companions;
    const newCompanions = oldCompanions?.map((el, ind) => {
      if (this.openDupPatientByPhonesDependentPopup?.companionsIndex === ind) {
        return {
          ...el,
          patient,
        };
      } else return el;
    });
    this.openDupPatientByPhonesDependentPopup = null;

    this.initCheckInDependentPerson = {
      ...this.openDupPatientByPhonesDependentPopup?.oldData,
      companions: newCompanions,
    };
  };

  handleClosePopupPatientByPhonesDependent = () => {
    this.openDupPatientByPhonesDependentPopup = null;
  };

  handleCloseCheckInDependentPersonPopup = () => {
    this.openCheckInDependentPersonPopup = false;
    this.duplicatePatientSelected = null;
    this.duplicatePatients = new PageResponse();
    this.listCompanionsSearchDuplicateIndex = new Set();
    this.customerSourceForCompanionDefault = null;
    this.searchDuplicatePatient = {
      ...new SearchObject(),
      phoneNumber: "",
      searchArchive: false,
    };
  };

  handleChangeFormSearchDependentPerson = async (obj) => {
    let { pageIndex, pageSize, ...ortherData } = obj;
    this.searchDuplicatePatient = {
      ...this.searchDuplicatePatient,
      pageIndex: pageIndex || this.searchDuplicatePatient?.pageIndex,
      pageSize: pageSize || this.searchDuplicatePatient?.pageSize,
      ...ortherData,
    };

    const listPatient = await this.handCheckPatientDependentPerson();

    if (listPatient?.length > 0) {
      // nếu tìm thấy duplicate patient
      this.listCompanionsSearchDuplicateIndex.add(obj?.currentIndex);
    }
    return listPatient;
  };

  setOpenConfirmCheckIns = (state) => {
    this.openConfirmCheckIns = state;
  };

  handCheckPatientDependentPerson = async () => {
    try {
      let dataApi = null;
      let data = null;
      try {
        dataApi = await pagingLead({ ...this.searchDuplicatePatient });
      } catch (error) {
        console.error(error);
      }

      if (dataApi?.data?.content?.length > 0) {
        this.duplicatePatients = dataApi?.data;
        this.openPopupSearchDependentPersonLead = true;
        data = dataApi?.data;
      } else {
        if (CHECK_ELASTIC_LEADS) {
          const elasticLeadResponse = await pagingElasticLeads({
            ...this.searchDuplicatePatient,
            searchArchive: false,
            keyword: this.searchDuplicatePatient?.phoneNumber,
          });
          if (elasticLeadResponse?.data?.content?.length > 0) {
            // Chuẩn hóa dữ liệu để xóa các trường date metadata
            const normalizedData = {
              ...elasticLeadResponse?.data,
              content: elasticLeadResponse?.data?.content?.map((item) =>
                normalizeDataForServer(item, true)
              ),
            };
            this.duplicatePatients = normalizedData;
            this.openPopupSearchDependentPersonLead = true;
            data = normalizedData;
          } else {
            const patientResponse = await pagingElasticPatient({
              // dùng chung biến search
              ...this.searchDuplicatePatient,
              keyword: this.searchDuplicatePatient?.phoneNumber,
            });
            if (patientResponse?.data?.content?.length > 0) {
              this.duplicatePatients = patientResponse?.data;
              this.openPopupCheckDuplicateDependentPerson = true;
              data = patientResponse?.data;
            } else {
              return [];
            }
          }
        } else {
          const patientResponse = await pagingElasticPatient({
            // dùng chung biến search
            ...this.searchDuplicatePatient,
            keyword: this.searchDuplicatePatient?.phoneNumber,
          });
          if (patientResponse?.data?.content?.length > 0) {
            this.duplicatePatients = patientResponse?.data;
            this.openPopupCheckDuplicateDependentPerson = true;
            data = patientResponse?.data;
          } else {
            return [];
          }
        }
      }

      return data?.content;
    } catch (error) {
      console.error(error);
      // toast.error("Đã có lỗi xảy ra vui lòng thử lại!");
    }
  };

  checkOutPatient = (obj, { setSubmitting }) => {
    return checkOut(obj)
      .then(({ data }) => {
        if (data && data?.responseStatus) {
          this.openFormCheckOut = false;
          toast.success("Check out thông tin thành công!");
        } else if (data && data?.responseStatus === false) {
          this.openConfirmCheckOut = data?.responseDetail;
          setSubmitting(false);
          return data?.responseStatus;
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Check out thông tin có lỗi");
      })
      .finally(() => setSubmitting(false));
  };

  handleCloseCreateOrEditPopup = () => {
    this.openFormCreateOrEdit = false;
  };

  handleCloseSearchListPopup = () => {
    this.openSearchLead = false;
  };

  handleCloseConfirmDialog = () => {
    this.openConfirmDelete = false;
    this.initialPatient = new Customer();
  };

  handleDeletePatient = (patient) => {
    this.initialPatient = { id: patient?.id };
    this.openConfirmDelete = true;
  };

  handleConfirmDeletePatient = async () => {
    return await voidedPatient(this.initialPatient?.id)
      .then(() => {
        if (
          this.pagePatient?.pageIndex > 1 &&
          this.pagePatient?.content?.length === 1
        ) {
          this.pagePatient.pageIndex -= 1;
        }
        toast.success("Xóa khách hàng thành công!");
        this.openConfirmDelete = false;
        this.pagingPatient();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Đã có lỗi xảy ra vui lòng thử lại!");
      });
  };

  handleSearchLead = async () => {
    try {
      let { data } = await pagingLead({ ...this.searchLead });
      this.leadPatient = data;
      this.openSearchLead = true;
    } catch (error) {
      console.error(error);
      toast.error("Đã có lỗi xảy ra khi tìm lead vui lòng thử lại!");
    }
  };

  handleChangeFormSearchLead = (values) => {
    let { pageIndex, pageSize, ...ortherData } = values;
    this.searchLead = {
      ...this.searchLead,
      pageIndex: pageIndex || this.searchLead?.pageIndex,
      pageSize: pageSize || this.searchLead?.pageSize,
      ...ortherData,
    };
    this.handleSearchLead();
  };

  //selected lead when search lead in create patient popup
  handleSelectLead = (lead) => {
    let dataLeadFormat = convertDataLead(lead);
    this.leadSelected = dataLeadFormat;
    this.initialPatient = { ...dataLeadFormat, id: null };
    this.openSearchLead = false;
  };

  // FORM DUPLICATE
  handleCheckDuplicationPatient = async () => {
    try {
      const { data } = await checkDuplicatePatient({
        ...this.searchDuplicatePatient,
      });
      if (data?.content?.length > 0) {
        this.openDuplicatePatientPopup = true;
        this.duplicatePatients = data;
      } else {
        const leadResponse = await pagingLead({
          ...this.searchLead,
        });
        if (leadResponse?.data?.content?.length > 0) {
          this.leadPatient = leadResponse?.data;
          this.openSearchLead = true;
        }
      }
      return data?.content;
    } catch (error) {
      console.error(error);
      toast.error("Đã có lỗi xảy ra vui lòng thử lại!");
    }
  };

  handleChangeFormSearchDuplicate = (obj) => {
    console.log("obj", obj);
    let { pageIndex, pageSize, patient, ...ortherData } = obj;
    if (!obj?.id) {
      this.searchDuplicatePatient = {
        ...this.searchDuplicatePatient,
        pageIndex: pageIndex || this.searchDuplicatePatient?.pageIndex,
        pageSize: pageSize || this.searchDuplicatePatient?.pageSize,
        patient,
        ...ortherData,
      };
      this.searchLead = {
        ...this.searchLead,
        pageIndex: pageIndex || this.searchLead?.pageIndex,
        pageSize: pageSize || this.searchLead?.pageSize,
        phoneNumber: patient?.phoneNumber,
        ...ortherData,
      };

      const listPatient = this.handleCheckDuplicationPatient();
      return listPatient;
    }
  };

  handleSelectDuplicatePatient = (patient) => {
    if (patient?.referralPartnerId) {
      patient.referralPartner = {
        id: patient?.referralPartnerId || "",
        name: patient?.referralPartnerName || "",
        code: patient?.referralPartnerCode || "",
      };
    }
    this.duplicatePatientSelected = patient;
    this.initialPatient = patient;
    this.openDuplicatePatientPopup = false;
  };

  handleCloseDuplicatePatientPopup = () => {
    this.openDuplicatePatientPopup = false;
  };

  handleSelectPatient = (patient) => {
    this.selectedPatient = patient;
    this.openShowPatientInfo = true;
  };
  handleCloseSelectPatient = () => {
    this.openShowPatientInfo = false;
  };

  handleExportExcelPatientList = async (searchObj) => {
    this.searchPatient = { ...this.searchPatient, ...searchObj };
    const isRoleSuperAdminPermission = isSuperAdmin();

    // Check điều kiện keyword và quyền
    if (!isRoleSuperAdminPermission && !this.searchPatient?.keyword?.trim()) {
      this.showSearchError = true;
      return;
    }
    if (
      !isRoleSuperAdminPermission &&
      this.searchPatient.keyword.trim().length <= CHECK_LENGTH_SEARCH_CUSTOMER
    ) {
      this.showSearchError = true;
      return;
    }

    // Nếu tới đây tức là pass điều kiện
    this.showSearchError = false;

    // Chuẩn bị dữ liệu để gửi lên server
    const search = this.normalizeSearchPatient(this.searchPatient);

    try {
      const response = await exportExcelPatientList(search);
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "DS_KHACH_HANG.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      } else {
        console.error("Export failed with status:", response.status);
      }
    } catch (error) {
      console.error("Error export excel report:", error);
    }
  };

  normalizeSearchPatient = (rawSearch = {}) => {
    const {
      province,
      district,
      commune,
      departmentId,
      appointmentDepId,
      visitDepId,
      invoiceDepId,
      ...rest
    } = rawSearch;
    return {
      ...rest,
      province: province?.id || null,
      district: district?.id || null,
      commune: commune?.id || null,
      departmentId: departmentId?.id || null,
      appointmentDepId: appointmentDepId?.id || null,
      invoiceDepId: invoiceDepId?.id || null,
      visitDepId: visitDepId?.id || null,
    };
  };

  handleSearchDuplicateInPersonal = async (obj) => {
    let { pageIndex, pageSize, ...ortherData } = obj;

    const newObj = {
      ...this.searchLead,
      pageIndex: pageIndex || this.searchLead?.pageIndex,
      pageSize: pageSize || this.searchLead?.pageSize,
      ...ortherData,
    };

    try {
      const { data } = await pagingLead({ ...newObj });
      if (data?.content?.length > 0) {
        this.searchLead = newObj;
        this.leadPatient = data;
        this.openSearchLead = true;
      }
      return data?.content || [];
    } catch (error) {
      console.error(error);
      // toast.error("Đã có lỗi xảy ra vui lòng thử lại!");
    }
  };

  handleSelectLeadSelectLeadPersonal = (patient) => {
    let convertPatient = convertDataLead(patient);
    this.openSearchLead = false;

    this.initialCheckIn = {
      patient: {
        ...convertPatient,
        phoneNumber: this.searchLead?.phoneNumber,
      },
      leadId: patient?.id,
      lead: patient,
      marketingType: patient?.marketingType,
      phoneNumber: this.searchLead?.phoneNumber,
      visitType: this.searchLead?.dataValue?.checkTypeVisit,
      receptionist: this.searchLead?.dataValue?.receptionist,
      issueDate: this.searchLead?.dataValue?.issueDate,
      department: this.searchLead?.dataValue?.department,
    };
  };

  handleCloseDupPatientByPhones = () => {
    this.openDupPatientByPhones = null;
  };

  handleSelectDupPatientByPhones = (patient) => {
    this.initialCheckIn = {
      ...this.openDupPatientByPhones?.dataValue,
      patient: {
        ...this.openDupPatientByPhones?.dataValue?.patient,
        id: patient?.id,
        displayName: patient.displayName,
        gender: patient?.gender
          ? patient?.gender
          : this.openDupPatientByPhones?.dataValue?.patient?.gender,
        birthDate: patient?.birthDate
          ? patient?.birthDate
          : this.openDupPatientByPhones?.dataValue?.patient?.birthDate,
      },
    };
    this.openDupPatientByPhones = null;
  };

  getCustomerSourceForCompanionDefault = async (platform) => {
    // when create patient ,firstPatientSource or currentPatientSource not provided
    //set default source have code NKV_VL in system config
    let companyCode = getSourceCustomerCompanionCode();
    let { data } = await pagingCustomerSource({
      listCustomerSourceCode: companyCode,
      pageSize: PAGESIZE_ALL,
      pageIndex: 1,
    });
    if (platform) {
      let currentPatientSource = data?.content?.find(
        (el) => el?.platform === platform
      );

      this.customerSourceForCompanionDefault = currentPatientSource;
    }
  };

  handleClosePopupSearchDependentPersonLead = () => {
    this.openPopupSearchDependentPersonLead = false;
  };

  handleSelectDependentPersonLeadPatient = (patient) => {
    let convertPatient = convertDataLead(patient);
    this.duplicatePatientSelected = { ...convertPatient, isLead: true };
    this.openPopupSearchDependentPersonLead = false;
    const oldCompanions = this.searchDuplicatePatient?.oldData?.companions;
    const newCompanions = oldCompanions?.map((el, ind) => {
      if (this.searchDuplicatePatient?.currentIndex === ind) {
        return {
          ...el,
          patient: convertPatient,
          leadId: patient?.id,
          lead: patient,
          // isMainPhoneNumber: true,
        };
      } else return el;
    });
    this.initCheckInDependentPerson = {
      ...this.searchDuplicatePatient?.oldData,
      companions: newCompanions,
    };
  };

  handleClosePopupCheckDuplicateDependentPerson = () => {
    this.openPopupCheckDuplicateDependentPerson = false;
  };

  handleSelectDuplicateDependentPerson = (patient) => {
    this.duplicatePatientSelected = patient;
    this.openPopupCheckDuplicateDependentPerson = false;
    const oldCompanions = this.searchDuplicatePatient?.oldData?.companions;
    const newCompanions = oldCompanions?.map((el, ind) => {
      if (this.searchDuplicatePatient?.currentIndex === ind) {
        return {
          ...el,
          patient: { ...patient, displayName: patient?.fullName },
        };
      } else return el;
    });
    this.initCheckInDependentPerson = {
      ...this.searchDuplicatePatient?.oldData,
      companions: newCompanions,
    };
  };

  handleChangeFormSearchDependentOnlyLead = async (obj) => {
    let { pageIndex, pageSize, ...ortherData } = obj;
    this.searchDuplicatePatient = {
      ...this.searchDuplicatePatient,
      pageIndex: pageIndex || this.searchDuplicatePatient?.pageIndex,
      pageSize: pageSize || this.searchDuplicatePatient?.pageSize,
      ...ortherData,
    };

    const listPatient = await this.handCheckPatientDependentOnlyLead();

    if (listPatient?.length > 0) {
      // nếu tìm thấy duplicate patient
      this.listCompanionsSearchDuplicateIndex.add(obj?.currentIndex);
    }
    return listPatient;
  };

  handCheckPatientDependentOnlyLead = async () => {
    try {
      let dataApi = null;
      let data = null;
      try {
        dataApi = await pagingLead({ ...this.searchDuplicatePatient });
      } catch (error) {
        console.error(error);
      }

      if (dataApi?.data?.content?.length > 0) {
        this.duplicatePatients = dataApi?.data;
        this.openPopupSearchDependentPersonLead = true;
        data = dataApi?.data;
      } else {
        if (CHECK_ELASTIC_LEADS) {
          const elasticLeadResponse = await pagingElasticLeads({
            ...this.searchDuplicatePatient,
            searchArchive: false,

            keyword: this.searchDuplicatePatient?.phoneNumber,
          });
          if (elasticLeadResponse?.data?.content?.length > 0) {
            // Chuẩn hóa dữ liệu để xóa các trường date metadata
            const normalizedData = {
              ...elasticLeadResponse?.data,
              content: elasticLeadResponse?.data?.content?.map((item) =>
                normalizeDataForServer(item, true)
              ),
            };
            this.duplicatePatients = normalizedData;
            this.openPopupSearchDependentPersonLead = true;
            data = normalizedData;
          }
        }
      }

      return data?.content || [];
    } catch (error) {
      console.error(error);
      // toast.error("Đã có lỗi xảy ra vui lòng thử lại!");
    }
  };

  resetStore = () => {
    this.openFormCreateOrEdit = false;
    this.openConfirmDelete = false;
    this.openSearchLead = false;
    this.openConfirmCheckIn = null;
    this.openConfirmCheckOut = null;
    this.openConfirmHasAppointment = null;
    this.openDuplicatePatientPopup = false;
    this.openShowPatientInfo = false;
    this.searchDuplicatePatient = { ...new SearchObject(), pageSize: 10, searchArchive: false };
    this.searchLead = { ...new SearchObject(), pageSize: 10 };
    this.pagePatient = new PageResponse();
    this.initialPatient = new Customer();
    this.leadSelected = null;
    this.duplicatePatients = null;
    this.duplicatePatientSelected = null;
    this.searchListDuplicatePatients = new SearchObject();
    this.selectedPatient = new Customer();
    this.openFormCheckOut = false;
    this.searchPatient = {
      ...new SearchObject(),
      fromDate: new Date(),
      toDate: new Date(),
    };
    this.initialCheckIn = {
      ...new CheckIn(),
      receptionist: getCurrentStaff(),
      department: localStorageService.getDefaultDepartment(),
    };
    this.initialCheckOut = {
      ...new CheckOut(),
    };
  };
}
